export default {
    patentReview: {
        list: {
            title: '核稿任務',
            newTask: '+ 新建核稿',
            empty: '暫無核稿任務',
            emptyHint: '上傳專利初稿檔案，即可開始形式核稿',
            rules: '條規則',
            tabTasks: '核稿任務列表',
            tabRules: '自定義規則管理',
        },
        status: {
            pending: '待處理',
            running: '執行中',
            completed: '已完成',
            failed: '失敗',
        },
        steps: {
            '1_parsing': '解析檔案',
            '2_extracting': '提取四要素',
            '3_figure_analysis': '附圖分析',
            '4_formal_check': '形式核稿',
            '5_substantive_check': '實質核稿',
            '6_finalizing': '匯總報告',
        },
        stepStatus: {
            done: '已完成',
            running: '執行中',
            failed: '失敗',
            pending: '等待中',
        },
        consistencyStep: {
            title: '交底一致性',
        },
        stabilityStep: {
            title: '穩定性分析',
        },
        upload: {
            title: '新建核稿任務',
            mainFile: {
                title: '上傳申請初稿',
                hint: 'PDF、DOCX',
            },
            figureSection: {
                addButton: '附圖',
                title: '附圖',
                hint: '支援拖拽或多選上傳',
            },
            disclosureSection: {
                addButton: '技術交底書',
                title: '技術交底書',
                hint: '支援拖拽或多選上傳',
            },
            customRulesSection: {
                addButton: '自定義規則',
                title: '自定義規則',
                dialogTitle: '自定義規則庫',
                searchPlaceholder: '搜尋規則庫名稱',
                historyGroup: '歷史規則庫',
                newGroup: '本次新上傳',
                uploadButton: '上傳規則',
                uploadFormats: '支援 .docx / .pdf / .pptx',
                confirm: '確認選擇',
                empty: '暫無規則庫，點擊「上傳規則」新增',
                rulesEmpty: '該規則庫未提取出規則',
                loadFailed: '加載規則庫列表失敗，請重試',
                uploadFailed: '上傳規則檔案失敗，請重試',
            },
            patentOffice: '受理局',
            officeHint: '切換後自動匹配對應法條與審查指南',
            officeComingSoon: '敬請期待',
            patentType: {
                label: '專利類型',
                invention: '發明',
                utility: '實用新型',
            },
            ruleType: {
                label: '規則類型',
                official: '官方規則',
                officialCustom: '官方規則+自定義規則',
            },
            chooseFile: '選擇檔案',
            fileHint: '支援 .docx / .pdf，最多 {max} 個檔案',
            confirm: '開始審查',
            uploading: '正在上傳…',
            cancel: '取消',
            removeFile: '移除',
        },
        detail: {
            backToList: '返回列表',
            taskHeader: {
                entry: '核稿審查',
                projectPackage: '專利審查項目包',
                unnamedTask: '未命名任務',
                progressTitle: '審查進度',
                autoRun: '自動運行',
                exportReport: '導出報告',
                exportNotReady: '核稿完成後可導出',
                finalizingCardSubtitle: '匯總結論',
                stepsExecutedCaption: '四項流程已執行',
                parsingCaption: '解析中',
                issueCountSuffix: '{count} 項問題',
            },
            materials: {
                mainFileTag: '專利申請檔案',
                figureTag: '附圖',
                disclosureTag: '交底書',
                attachmentTag: '附件',
            },
            parsing: {
                fileName: '檔案名',
                fileNamePending: '正在識別主檔案…',
                hint: '正在解析上傳檔案的文本內容…',
            },
            extracting: {
                title: '發明名稱',
                abstract: '摘要',
                claims: '權利要求書',
                specification: '說明書',
                figures: '附圖',
                expand: '展開',
                collapse: '收起',
                empty: '暫無內容',
            },
            check: {
                pass: '通過',
                passCollapsed: '通過（{count} 條）',
                filterAll: '全部',
                filterInfo: '提示',
                filterWarning: '警告',
                filterError: '錯誤',
                filterCritical: '嚴重',
                location: '位置',
                suggestion: '修改建議',
                guidelineSource: '依據來源',
                empty: '暫無形式核稿問題',
                summaryPattern: '發現 {count} 處可定位的形式或企業規範問題',
                statTitle: '發現{count}處形式問題，其中，{officialCount}項違反官方規則，{customCount}項違反企業規則。',
                statFormalIssues: '形式問題',
                statOfficialViolations: '違反官方規則',
                statCustomViolations: '違反企業規則',
                summaryTitle: '形式檢查·總結結論',
                summaryRequireModify: '{count}項需修改',
                summaryRequireConfirm: '{count}項需人工確認',
                summaryStats: '共{total}條規則·{requireModify}項·{requireConfirm}項·{pass}項已通過',
                systemRules: '系統規則',
                customRules: '企業規則',
                legendPass: '通過',
                legendFail: '不通過',
                legendPending: '需人工確認',
                summaryAllPassed: '全部通過',
                coverageTitle: '規則覆蓋',
                coverageSource: '規則來源',
                coverageTotal: '規則數',
                coverageFail: '不通過',
                coverageVerify: '待確認',
                coveragePending: '待核查',
                coveragePassed: '通過',
            },
            table: {
                tabIssues: '問題定位表',
                tabCoverage: '檢查覆蓋',
                sourceOfficial: '官方規則',
                sourceCustom: '企業規則',
                sourceCustomEmpty: '暫無企業自定義規則命中數據',
                searchPlaceholder: '搜索權項、問題或法條',
                columnIndex: '#',
                columnLocation: '具體位置',
                columnIssue: '檢查結果/問題',
                columnStatute: '適用法條/規則依據',
                columnSuggestion: '修改建議',
                columnEvidence: '證據',
                evidenceEmpty: '—',
                statusPending: '需修改',
                statusApplied: '已修改',
                statusIgnored: '已忽略',
                statusPass: '已通過',
                coverageColumnType: '規則類型',
                coverageColumnRule: '檢查規則',
                coverageColumnContent: '規則內容',
                coverageColumnResult: '檢查結果',
                coverageResultEmpty: '—',
                coverageResultFound: '發現問題',
                ruleTypeOfficial: '官方規則',
                ruleTypeCustom: '企業規則',
                itemUnit: '項',
                columnPatentSection: '專利章節',
                columnCheckRule: '檢查規則',
                columnCheckResult: '檢查結果',
                columnErrorReason: '錯誤理由',
                editButton: '編輯',
                adoptButton: '採納改文',
                locateButton: '錯誤定位',
                locationModalTitle: '錯誤定位',
                locationModalContent: '定位信息：{location}',
                locationModalClose: '關閉',
                locationModalRuleLabel: '檢查規則',
                locationModalLocationLabel: '位置',
                locationModalSuggestionLabel: '修改建議',
                locationModalBoundaryLabel: '適用邊界',
                locationModalSourceTitle: '原稿內容',
                locationModalPositionUnresolved: '未能確定錯誤位置',
                statusRequireModify: '需修改',
                statusRequireConfirm: '需人工確認',
                statusPendingVerification: '待核查',
            },
            finalizing: {
                conclusion: '總體結論',
                totalRules: '規則總數',
                passCount: '通過',
                warningCount: '警告',
                errorCount: '錯誤',
                criticalCount: '嚴重錯誤',
                conclusions: {
                    formal: '形式核稿結論',
                    art26_3: '第26條第3款結論',
                    art26_4: '第26條第4款結論',
                },
                riskMatrix: {
                    title: '實質核稿風險等級分布',
                    high: '高風險',
                    medium: '中風險',
                    low: '低風險',
                },
                conclusionValue: {
                    compliant: '符合',
                    risky: '基本符合但有風險',
                    non_compliant: '可能不符合',
                    insufficient: '材料不足無法完整判斷',
                },
                dimensionConclusions: {
                    title: '檢查維度結論',
                    unresolved: '未判定',
                },
            },
            featureMapping: {
                figuresNone: '本申請未包含附圖',
                figuresFailed: '附圖識別未完成，本次判斷未結合附圖內容',
                figureNoLabel: '圖{no}',
                figureNoUnknown: '圖號未標註',
                figureConfidenceMedium: '圖號為推斷結果',
                figureConfidenceLow: '圖號無法確定',
                figureSignsLabel: '圖面標引',
                figureNoSigns: '圖面未見標引',
            },
            substantive: {
                filterHigh: '高風險',
                filterMedium: '中風險',
                filterLow: '低風險',
                filterAll: '全部',
                needsInventorConfirm: '需發明人確認',
                boundaryLabel: '適用邊界',
                summaryPattern: '發現 {count} 處實質性問題，建議逐項核實',
                issuesLocations: '形式問題定位',
                title: '實質核稿',
                checkResultTitle: '檢查結果',
                issuesCount: '實質問題',
                highRiskCount: '高風險問題',
            },
            supplement: {
                title: '必要補充材料清單',
                columns: {
                    content: '需補充內容',
                    reason: '原因',
                    targetStatute: '用於解決的法條問題',
                    suggestedLocation: '建議補充位置',
                },
                empty: '暫無必要補充材料',
            },
            failed: {
                retryHint: '核稿任務執行失敗，可返回列表重新上傳檔案',
            },
            reportLoadFailed: {
                message: '加載核稿報告失敗，請重試',
                retry: '重新加載',
            },
            stepRunning: '該步驟正在執行，完成後可查看結果…',
            noStepSelected: '請選擇一個步驟查看詳情',
        },
        customRuleDocuments: {
            delete: '刪除',
            deleteConfirm: '確認刪除？',
            confirmYes: '確認',
            confirmNo: '取消',
            empty: '暫無規則文檔',
            rulesEmpty: '該文檔未提取出規則',
            rulesLoadFailed: '加載規則明細失敗，請重試',
            rulesCount: '{count} 條規則',
            status: {
                uploaded: '已上傳',
                parsing: '解析中',
                parsed: '已解析',
                parse_failed: '解析失敗',
            },
            upload: {
                title: '上傳規則文檔',
                addButton: '上傳規則文檔',
                fileTitle: '上傳規則文檔',
                fileHint: 'PDF、DOCX',
                chooseFile: '選擇檔案',
                removeFile: '移除',
                confirm: '開始上傳',
                uploading: '正在上傳…',
            },
            loadFailed: '加載規則文檔失敗，請重試',
            uploadFailed: '上傳規則文檔失敗，請重試',
            updateFailed: '更新失敗，請重試',
            deleteSuccess: '刪除成功',
            deleteFailed: '刪除失敗，請重試',
        },
        errors: {
            createTaskFailed: '創建核稿任務失敗，請重試',
            loadTaskFailed: '加載任務狀態失敗，請重試',
            loadReportFailed: '加載核稿報告失敗，請重試',
            loadTasksFailed: '加載任務列表失敗，請重試',
            unsupportedOffice: '暫不支援該受理局',
            exportReportFailed: '導出核稿報告失敗，請重試',
        },
    },
};
